<div class="content-body">
  <div class="row form-head mt-4 mx-1">
    <div>
      <a (click)="goback()" class="ac-goback-btn">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="24"
          viewBox="0 -960 960 960"
          width="24"
        >
          <path d="M400-80 0-480l400-400 71 71-329 329 329 329-71 71Z" />
        </svg>
        Go Back
      </a>
    </div>
  </div>
  <div class="container-fluid mt-4">
    <div class="row d-sm-flex d-block align-items-center mb-4">
      <div class="d-sm-flex rowp d-block align-items-center mb-4">
        <div
          class="me-auto d-sm-flex"
          style="align-items: center; display: -webkit-inline-box"
        >
          <h2 class="text-black font-w600 mb-0 ac-headcreat me-auto">
            Create Dispute
          </h2>
        </div>
      </div>
    </div>

    <div
      class="row justify-content-center align-items-center g-5 mb-4 ac-mob-dnone progress-bar-wrapper"
    >
      <div class="col-sm-12 col-md-4 ac-phead">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="24px"
          viewBox="0 0 24 24"
          width="24px"
          fill="#000000"
        >
          <path d="M0 0h24v24H0V0z" fill="none" />
          <path
            d="M19.5 3.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2v20l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5zM19 19.09H5V4.91h14v14.18zM6 15h12v2H6zm0-4h12v2H6zm0-4h12v2H6z"
          />
        </svg>
        <p class="pt-1">Invoice Information</p>

        <div class="progress ac-progress">
          <div
            id="info"
            role="progressbar"
            class="progress-bar ac-proinfo"
            [style.width]="infovalue + '%'"
            [attr.aria-valuenow]="infovalue"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
      </div>
      <div class="col-sm-12 col-md-4 ac-phead">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          enable-background="new 0 0 24 24"
          height="24px"
          viewBox="0 0 24 24"
          width="24px"
          fill="#000000"
        >
          <g>
            <rect fill="none" height="24" width="24" />
            <g>
              <path
                d="M19,5v14H5V5H19 M19,3H5C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V5C21,3.9,20.1,3,19,3L19,3z"
              />
            </g>
            <path d="M14,17H7v-2h7V17z M17,13H7v-2h10V13z M17,9H7V7h10V9z" />
          </g>
        </svg>
        <p class="pt-1">Summary</p>
        <div class="progress ac-progress">
          <div
            id="summary"
            role="progressbar"
            class="progress-bar ac-prosummary"
            [style.width]="summaryvalue + '%'"
            [attr.aria-valuenow]="summaryvalue"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
      </div>

      <div class="col-sm-12 col-md-4 ac-phead">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          enable-background="new 0 0 24 24"
          height="24px"
          viewBox="0 0 24 24"
          width="24px"
          fill="#000000"
        >
          <g>
            <rect fill="none" height="24" width="24" />
          </g>
          <g>
            <g>
              <path
                d="M23,11.99l-2.44-2.79l0.34-3.69l-3.61-0.82L15.4,1.5L12,2.96L8.6,1.5L6.71,4.69L3.1,5.5L3.44,9.2L1,11.99l2.44,2.79 l-0.34,3.7l3.61,0.82L8.6,22.5l3.4-1.47l3.4,1.46l1.89-3.19l3.61-0.82l-0.34-3.69L23,11.99z M19.05,13.47l-0.56,0.65l0.08,0.85 l0.18,1.95l-1.9,0.43l-0.84,0.19l-0.44,0.74l-0.99,1.68l-1.78-0.77L12,18.85l-0.79,0.34l-1.78,0.77l-0.99-1.67l-0.44-0.74 l-0.84-0.19l-1.9-0.43l0.18-1.96l0.08-0.85l-0.56-0.65l-1.29-1.47l1.29-1.48l0.56-0.65L5.43,9.01L5.25,7.07l1.9-0.43l0.84-0.19 l0.44-0.74l0.99-1.68l1.78,0.77L12,5.14l0.79-0.34l1.78-0.77l0.99,1.68l0.44,0.74l0.84,0.19l1.9,0.43l-0.18,1.95l-0.08,0.85 l0.56,0.65l1.29,1.47L19.05,13.47z"
              />
              <polygon
                points="10.09,13.75 7.77,11.42 6.29,12.91 10.09,16.72 17.43,9.36 15.95,7.87"
              />
            </g>
          </g>
        </svg>

        <p class="pt-1">Confirmation</p>

        <div class="progress ac-progress">
          <div
            id="confirm"
            role="progressbar"
            class="progress-bar ac-proconfm"
            [style.width]="confirmvalue + '%'"
            [attr.aria-valuenow]="confirmvalue"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
      </div>
    </div>

    <!-- section 1 -->
    <section *ngIf="selectedSection == 'invoice-info'">
      <app-create-dispute-invoice-info
        (selectSection)="selectDisputeSection($event)"
      ></app-create-dispute-invoice-info>
    </section>

    <!-- section 2 -->
    <section *ngIf="selectedSection == 'dispute-summary'">
      <app-create-dispute-summary
        (selectSection)="selectDisputeSection($event)"
      ></app-create-dispute-summary>
    </section>
  </div>
</div>
